import React, { useState, useEffect } from "react";
import HeroInfo from "../components/InfoPsre/Hero";
import ParaghraphSection from "../components/InfoPsre/Paraghraph";
import Layout from "../layout/Main";
import { http } from "../misc/http";

export default function InfoPsreNew() {
  const [about, setAbout] = useState([]);

  const handleGetParagraph = async () => {
    let params = {
      method: "GET",
      path: "settings/about/getAll",
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      setAbout(data.data[0]);
    }
  };

  useEffect(() => {
    handleGetParagraph();
  }, []);
  // console.log("checking about ", about);
  return (
    <Layout>
      <HeroInfo
        thumbnail={about.thumbnail ? about.thumbnail : null}
      />
      <ParaghraphSection
        about={about.description ? about.description : null}
      />
    </Layout>
  );
}
